import React, { useState } from "react";
import { Button, ModalBody } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import { useDispatch } from "react-redux";
import LoginLoaderButton from "../../../../../../Common/Loader/LoginLoaderButton";
import { approveSubmissionContest } from "../../../../../../../redux/contest/action";
import CustomReactQuill2forMessage from "../../../../../../Common/CustomeLabel/ReactQuill/CustomReactQuill2forMessage";

export default function RejectDocumentModel({ setModelreject, pd, posts }) {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        message: Yup.string()
            .required("Message is required")
            .trim() 
            .min(1, "Message cannot be empty") 
            .max(1000, "Message cannot exceed 1000 characters")
            .test('not-only-spaces', 'Please enter a valid message', value => {
                return value !== null && value.trim().length > 0; 
            }),
    });

    const handleSubmit = (values) => {
        setLoading(true);

        const data = {
            type: "2",
            id: pd?.id,
            status: "14",
            message: values.message,
            post_id: posts?.id,
        };

        console.log(data, 'Submitted Data');  

        ReuploadApproveSubmission(data);
    };

    const ReuploadApproveSubmission = (data) => {
        dispatch(approveSubmissionContest(data, setLoading));
        setModelreject(false);
        setLoading(false);
    };

    return (
        <Formik
            initialValues={{ message: "" }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({ setFieldValue, values }) => (  
                <Form>
                    <div className ="add-task">
                        <h6>Request changes</h6>
                        <button
                            type="button"
                            onClick={() => setModelreject((state) => !state)}
                            className ="btn close-button"
                        >
                            <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
                                alt="Close"
                            />
                        </button>
                    </div>
                    <ModalBody>
                        <h4>Are you sure you want to request changes?</h4>
                        <p>Please write a proper message detailing what changes are needed in the document:</p>

                        <CustomReactQuill2forMessage
                            title={"Enter Description"}
                            value={values?.message}
                            setFieldValue={setFieldValue}
                            name={"message"}
                        />
                        <ErrorMessage name="message" component="div" className ="error" />
                    </ModalBody>
                    <div className ="modal-footer" style={{ marginBottom: 10 }}>
                        <button
                            disabled={loading}
                            onClick={() => setModelreject((state) => !state)}
                            className ="btn"
                            style={{ background: "#fff", color: "black", border: "2px solid" }}
                            type="button"
                        >
                            Cancel
                        </button>
                    </div>
                    <div className ="modal-footer">
                        <button
                            disabled={loading}
                            type="submit"
                            className ="btn"
                        >
                            {loading ? <LoginLoaderButton /> : "YES"}
                        </button>
                    </div>
                </Form>
            )}
        </Formik>
    );
}
